import { useEffect } from 'react';

import { defaultMetricMode } from '../definitions/metricMode';
import { defaultPostingSource } from '../definitions/postingsSource';
import {
  type FilterConsistencyState,
  getActiveFilterMap,
} from '../engine/filterGroupConsistency';
import type { FilterAction } from '../engine/filterReducer';
import { FilterId, FilterType } from '../types/filters';

export const useSyncMetricModePostingSource = ({
  filterState,
  dispatch,
}: {
  filterState: FilterConsistencyState;
  dispatch: React.Dispatch<FilterAction>;
}) => {
  const activeFilterMap = getActiveFilterMap(filterState);
  const postingSourceFilter = activeFilterMap.get(FilterId.POSTINGS_SOURCE);
  const metricModeFilter = activeFilterMap.get(FilterId.METRIC_MODE);

  useEffect(() => {
    if (
      !postingSourceFilter ||
      postingSourceFilter.type !== FilterType.STATIC_LIST
    ) {
      return;
    }
    if (!metricModeFilter || metricModeFilter.type !== FilterType.STATIC_LIST) {
      return;
    }

    const isNonUnifiedSelected = postingSourceFilter.selections.some(
      (selection) => selection.id !== defaultPostingSource.value
    );
    const isMetricModeWeighted = metricModeFilter.selections.some(
      (selection) => selection.id !== defaultMetricMode.value
    );

    if (isNonUnifiedSelected && isMetricModeWeighted) {
      dispatch({
        type: 'UPDATE_FILTER',
        filter: { ...metricModeFilter, selections: [] },
      });
    }
  }, [dispatch, metricModeFilter, postingSourceFilter]);
};
